import React from 'react';
import { View, StyleSheet, TouchableOpacity, Animated } from 'react-native';
import { COLORS } from '../../theme/themeTokens';
import { COLORS_WRONG } from '../../theme/colorsWrong';

interface PINDotsProps {
    pin: string;
    pinLength?: number;
    error?: string | null;
    shakeAnimation?: Animated.Value;
    onPress?: () => void;
}

const PINDots: React.FC<PINDotsProps> = ({
    pin,
    pinLength = 4,
    error,
    shakeAnimation,
    onPress,
}) => {
    const dots = (
        <View style={styles.dotsRow}>
            {Array.from({ length: pinLength }).map((_, index) => (
                <View
                    key={index}
                    style={[
                        styles.dot,
                        index < pin.length && styles.dotFilled,
                        error ? styles.dotError : null,
                    ]}
                />
            ))}
        </View>
    );

    const animatedDots = shakeAnimation ? (
        <Animated.View
            style={[
                styles.dotsContainer,
                { transform: [{ translateX: shakeAnimation }] },
            ]}>
            {dots}
        </Animated.View>
    ) : (
        <View style={styles.dotsContainer}>{dots}</View>
    );

    return (
        <TouchableOpacity
            activeOpacity={1}
            onPress={onPress}
            style={styles.touchable}>
            {animatedDots}
        </TouchableOpacity>
    );
};

const styles = StyleSheet.create({
    touchable: {
        alignSelf: 'center',
    },
    dotsContainer: {
        marginBottom: 16,
    },
    dotsRow: {
        flexDirection: 'row',
        justifyContent: 'center',
        gap: 26,
    },
    dot: {
        width: 26,
        height: 26,
        borderRadius: 13,
        borderWidth: 2,
        borderColor: COLORS.steelNavy,
        backgroundColor: 'transparent',
    },
    dotFilled: {
        backgroundColor: COLORS.steelNavy,
    },
    dotError: {
        borderColor: COLORS_WRONG.error,
        backgroundColor: COLORS_WRONG.error,
    },
});

export default PINDots;
